import { Shark, SmartModel, Utils } from "shark-mvc";
// import systemComponent from "../components/systemComponent";
import notificationManager from "../managers/notificationManager";

import NousCoreModel from "./NousCoreModel";
import OrganizationMembership from "./OrganizationMembership";

class User extends NousCoreModel {
	static NOTIFICATION_TYPE_NONE = "none";
	static NOTIFICATION_TYPE_BEEP = "beep";
	static NOTIFICATION_TYPE_SOUND = "sound";
	static NOTIFICATION_TYPE_VOICE = "voice";

	static SUBSCRIPTION_TYPE_ENTERPRISE = "enterprise";
	static SUBSCRIPTION_TYPE_FREE = "free";
	static SUBSCRIPTION_TYPE_STARTER = "starter";
	static SUBSCRIPTION_TYPE_TEAM = "team";

	confirmed = false;
	createdById = ""; //nope?
	firstName = "";
	email = "";
	lastActivityAt = "0000-00-00 00:00:00";
	lastLoginAt = "0000-00-00 00:00:00";
	lastName = "";
	otp = "";
	password = "";
	pictureURL = "";
	preferences = {
		internalCost: 0,
		externalCost: 0,
		pushNotificationEnabled: true,
		pushNotificationFrequency: 30,
		notifications: {
			frequency: 10,
			type: "none",
			voice: "",
			volume: .8,
		},
		notificationEnabled: true,
		notificationFrequency: 10,
		notificationVoice: "",
		theme: "theme-2",
		workingHours: [
			{
				end: "13:00",
				start: "09:30",
			},
			{
				end: "18:30",
				start: "14:00",
			},
		],
		workDays: {
			sunday: false,
			monday: true,
			tuesday: true,
			wednesday: true,
			thursday: true,
			friday: true,
			saturday: false,
		}
	};
	prefWHStartHH = 9;
	prefWHStartMM = 0;
	prefWHEndHH = 18;
	prefWHEndMM = 0;
	preserveLogin = false;
	subscriptionType = User.SUBSCRIPTION_TYPE_FREE;
	updatedById = ""; //nope?
	isActive = false;

	_feature_customer = false;
	_feature_project_create = false;

	__acceptPrivacyTermCondition = false;
	__fullName = "";
	__initials = "";
	__passwordConfirm = "";
	__subscriptionTypeLabel = "";
	__userCanDeleteWorkingHours = true;
	__themeLabel = "";
	__voiceNotificationEnabled = false;	

	constructor (data) {
		super(data, "User");
		
		if (data) {
			this.import(data);
		}
	}

	addWorkingHours () {
		const newWorkingHours = {
			end: "13:00",
			start: "09:00",
		};

		const preferences = this.preferences;

		preferences.workingHours.push(newWorkingHours);

		this.set({
			preferences,
		});

		this.parseWorkHours();
	}

	deleteWorkingHours (index) {
		const preferences = this.preferences;
		preferences.workingHours.splice(index, 1);

		this.set({
			preferences,
		});

		this.parseWorkHours();
	}

	export (options) {
		let exportData = {};

		if (typeof options === "string") {
			switch (options) {
				case "logIn":
					exportData.email = this.email;
					exportData.password = this.password;
					break;
			}
		}
		else {
			exportData = super.export();
			exportData.email = this.email;
			exportData.name = this.firstName;
			exportData.surname = this.lastName;

			const workingHours = this.preferences.workingHours.map(item => item.export());
			const preferences = Object.assign({}, this.preferences);
			preferences.workingHours = workingHours;

			exportData.preferences = JSON.stringify(preferences);
		}
		
		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		this.importDateField("lastActivityAt", data.lastActivityAt);
		this.importDateField("lastLoginAt", data.lastLoginAt);

		if (typeof this.preferences.workingHours === "string") {
			this.preferences.workingHours = [
				{
					end: "13:00",
					start: "09:30",
				},
				{
					end: "18:30",
					start: "14:00",
				}
			];
		}

		// this.subscriptionType = User.SUBSCRIPTION_TYPE_FREE;

		this.parseFeature();
		this.parseNotificationPreferences();
		this.parseSubscriptionType();
		this.parseWorkHours();
		this.parseThemePreferences();

		this.password = "";

		this.__fullName = this.firstName + " " + this.lastName;
		this.__initials = this.firstName.slice(0, 1).toUpperCase() + this.lastName.slice(0, 1).toUpperCase();
	}

	// onPreferences_notificationEnabledChanged () {
	// 	Shark.render();
	// }

	// onPreferences_notificationVoiceChanged () {
	// 	notificationManager.setActiveVoice(true);
	// }

	includesAny (array1, array2) {
		for (let i = 0; i < array2.length; i++) {
			if (array1.includes(array2[i])) {
				return true;
			}		
		}
		return false;
	}

	onPreferences_notifications_typeChanged () {
		notificationManager.notifyShouldBeWorking();
		this.parseNotificationPreferences();
		Shark.render();
	}

	onPreferences_notifications_voiceChanged () {
		notificationManager.setActiveVoice(true);
	}

	onPreferences_notifications_volumeChanged () {
		notificationManager.notifyShouldBeWorking();
	}

	parseFeature () { 
		let feature_project_create = Shark.$store.allUserMembershipList && Shark.$store.allUserMembershipList.length > 0 ? this.includesAny([OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_OWNER], Shark.$store.allUserMembershipList.filter(membership => membership.userGuid === this.guid).map(item => item.role)) : true;
		let feature_organization = Shark.$store.allUserMembershipList && Shark.$store.allUserMembershipList.length > 0 ? true : false;
		let feature_user = Shark.$store.allUserMembershipList && Shark.$store.allUserMembershipList.length > 0 ? this.includesAny([OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_OWNER], Shark.$store.allUserMembershipList.filter(membership => membership.userGuid === this.guid).map(item => item.role)) : true;

		switch (this.subscriptionType) {
			case User.SUBSCRIPTION_TYPE_ENTERPRISE:
				this._feature_customer = true;
				this._feature_organization = true;
				this._feature_organization_create = true;
				this._feature_permission = true;
				this._feature_project_create = feature_project_create;
				this._feature_user = feature_user;
				this._feature_stats_calendar = true;
				break;
			case User.SUBSCRIPTION_TYPE_FREE:
				this._feature_customer = false;
				this._feature_organization = feature_organization;
				this._feature_organization_create = false;
				this._feature_permission = false;
				this._feature_project_create = false;
				this._feature_user = feature_user;
				this._feature_stats_calendar = false;
				break;
			case User.SUBSCRIPTION_TYPE_STARTER:
				this._feature_customer = false;
				this._feature_organization = feature_organization;
				this._feature_organization_create = false;
				this._feature_permission = false;
				this._feature_project_create = true;   
				this._feature_user = feature_user;
				this._feature_stats_calendar = false;
				break;
			case User.SUBSCRIPTION_TYPE_TEAM:
				this._feature_customer = true;
				this._feature_organization = true;
				this._feature_organization_create = true;
				this._feature_permission = true;
				this._feature_project_create = feature_project_create;  
				this._feature_user = feature_user;
				this._feature_stats_calendar = true;
				break;
		}
	}

	parseNotificationPreferences () {
		this.__voiceNotificationEnabled = this.preferences.notifications.type === User.NOTIFICATION_TYPE_VOICE;
		if (Shark.$store.notificationTypeMap) {
			this.__notificationLabel = Utils.safp(Shark.$store.notificationTypeMap, "type", this.preferences.notifications.type).label;
			this.__notificationIcon = Utils.safp(Shark.$store.notificationTypeMap, "type", this.preferences.notifications.type).icon;
		}
	}

	parseSubscriptionType() {
		switch (this.subscriptionType) {
			case User.SUBSCRIPTION_TYPE_ENTERPRISE:
				this.__subscriptionTypeLabel = "Enterprise";
				break;
			case User.SUBSCRIPTION_TYPE_FREE:
				this.__subscriptionTypeLabel = "Free";
				break;
			case User.SUBSCRIPTION_TYPE_STARTER:
				this.__subscriptionTypeLabel = "Starter";
				break;
			case User.SUBSCRIPTION_TYPE_TEAM:
				this.__subscriptionTypeLabel = "Team";
				Shark.set({
					userRoleAssignableMap: Shark.$store.userRoleMap.filter(item => ![OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(item.id)),
				});	
				break;
		}

		this.__isSubscriptionEnterprise = this.subscriptionType === User.SUBSCRIPTION_TYPE_ENTERPRISE;
		this.__isSubscriptionFree = this.subscriptionType === User.SUBSCRIPTION_TYPE_FREE;
		this.__isSubscriptionStarter = this.subscriptionType === User.SUBSCRIPTION_TYPE_STARTER;
		this.__isSubscriptionTeam = this.subscriptionType === User.SUBSCRIPTION_TYPE_TEAM;
	}

	parseThemePreferences () {
		if (Shark.$store.labels) {
			this.__themeLabel = Shark.$store.labels[this.preferences.theme.replace("-", "_")];
		}
	}

	parseWorkHours () {
		this.preferences.workingHours = this.preferences.workingHours.map((item, index) => {
			const newRange = Shark.getInstance("__smart__", item instanceof SmartModel ? item.export() : item);
			newRange.__index = index;
			return newRange;
		});

		this.__userCanDeleteWorkingHours = this.preferences.workingHours.length > 1;
	}

	validateLogin () {
		const errors = [];

		if (this.email.trim() === "") { //Serve la validazione dell'email
			errors.push({
				error: "L'indirizzo eMail è obbligatorio.",
				field: "email",
			});
		}

		if (this.password.trim() === "") { //Serve la validazione dell'email
			errors.push({
				error: "La password è obbligatoria.",
				field: "password",
			});
		}

		return errors;
	}

	validateResetPassword () {
		const errors = [];

		if (this.password.trim() === "") {
			errors.push({
				error: "La password è obbligatoria.",
				field: "password",
			});
		}

		if (this.__passwordConfirm.trim() === "") {
			errors.push({
				error: "La conferma della password è obbligatoria.",
				field: "__passwordConfirm",
			});
		}

		if (this.password.trim() !== this.__passwordConfirm.trim()) {
			errors.push({
				error: "Le password non corrispondono",
				field: "__passwordConfirm",
			});
		}

		return errors;
	}
}

Shark.registerModel("User", User);

export default User;